import React from 'react';
import { TableFilters, TableFilterSelect, Input } from '../../design-system';
import { INPUT_ERRORS, lastVisitedAtOptions, rolesV2 } from '../../const';
import { i18n } from '../../i18n';

interface Props {
  username?: string;
  belongsTo?: string;
  country?: string;
  lastVisitedAt?: any;
  setStates: any;
}

export const Filters: React.FC<Props> = ({
  username = '',
  belongsTo,
  country = '',
  lastVisitedAt,
  setStates,
}: Props) => {
  return (
    <TableFilters>
      <Input
        label={i18n.t('label.userName')}
        data-size={'medium'}
        onChange={(e) => {
          const value = e.target.value.toLowerCase();
          setStates('username', value);
        }}
        helperText={username.length > 30 ? INPUT_ERRORS.NOT_VALID.USERNAME_LENGTH : ''}
        alwaysShowHelperText
      />
      <TableFilterSelect
        label={i18n.t('label.belongsTo')}
        options={rolesV2}
        value={belongsTo}
        onChange={(e) => setStates('force', { belongsTo: e.target.value })}
      />
      <TableFilterSelect
        label={i18n.t('label.lastVisitedAt')}
        options={lastVisitedAtOptions}
        value={lastVisitedAt}
        onChange={(e) => setStates('force', { lastVisitedAt: e.target.value })}
      />
      <Input
        label={i18n.t('label.country')}
        data-size={'medium'}
        onChange={(e) => {
          const value = e.target.value.toLowerCase();
          setStates('country', value);
        }}
        helperText={country.length > 85 ? INPUT_ERRORS.NOT_VALID.COUNTRY_LENGTH : ''}
        alwaysShowHelperText
        withoutSpace
      />
    </TableFilters>
  );
};
